import { FC, useState } from 'react'
import { CircularProgress } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { closeModal, modalPropsSelector } from 'store/modals/modalSlice'
import { ThemeButton } from '../../../buttons'
import { DeleteIcon } from '../../../svg'
import {
  DeleteInstanceActionsWrapper,
  DeleteInstanceSubtitle,
  DeleteInstanceTitle,
  DeleteInstanceWrapper
} from './deleteIntegrationInstance.styles'

/* Confirms removing an outbound instance. The caller owns the write and its toasts; this only asks. */
const DeleteApplicationInstance: FC = () => {
  const dispatch = useAppDispatch()
  const modalProps = useAppSelector(modalPropsSelector)
  const props = modalProps.props?.deleteApplicationInstanceProps
  const [submitting, setSubmitting] = useState(false)

  const handleClose = () => {
    if (submitting) return
    dispatch(closeModal())
  }

  const handleDelete = async () => {
    if (!props) return
    setSubmitting(true)
    await props.onConfirm()
    setSubmitting(false)
    dispatch(closeModal())
  }

  if (!props) return null

  return (
    <DeleteInstanceWrapper>
      <DeleteInstanceTitle>Delete Instance “{props.displayName}”</DeleteInstanceTitle>
      <DeleteInstanceSubtitle>
        Onyxia’s access to the connected Jira site will be revoked and this instance will no longer appear on this page.
      </DeleteInstanceSubtitle>
      <DeleteInstanceActionsWrapper>
        <ThemeButton themevariant="tertiary" onClick={handleClose} disabled={submitting}>
          Go Back
        </ThemeButton>
        <ThemeButton
          themevariant="primary"
          type="button"
          onClick={handleDelete}
          disabled={submitting}
          endIcon={submitting && <CircularProgress size="20px" />}
        >
          <>
            <DeleteIcon />
            Delete
          </>
        </ThemeButton>
      </DeleteInstanceActionsWrapper>
    </DeleteInstanceWrapper>
  )
}

export default DeleteApplicationInstance
